import mujlogo from "../assets/mujlogo.png";
import smulogo from "../assets/smulogo.png";

export const universities = [
  {
    university: "Manipal University Jaipur",
    courses: [
      
      {
        id: "01",
        title: "BCom",
        price: "₹ 1,05,000",
        color: "#FF6B6B",
        image: mujlogo,
      },
      {
        id: "02",
        title: "BBA",
        price: "₹ 1,44,000",
        color: "#00B894",
        image: mujlogo,
      },
      {
        id: "03",
        title: "BCA",
        price: "₹ 1,44,000",
        color: "#0984E3",
        image: mujlogo,
      },
      {
        id: "04",
        title: "MA",
        price: "₹ 80,000",
        color: "#E17055",
        image: mujlogo,
      },
      {
        id: "05",
        title: "MSc",
        price: "₹ 84,000",
        color: "#00CEC9",
        image: mujlogo,
      },
      {
        id: "06",
        title: "MCom",
        price: "₹ 1,08,000",
        color: "#3867D6",
        image: mujlogo,
      },
      {
        id: "07",
        title: "MBA",
        price: "₹ 1,84,000",
        color: "#FC5C65",
        image: mujlogo,
      },
      {
        id: "08",
        title: "MCA",
        price: "₹ 1,64,000",
        color: "#A55EEA",
        image: mujlogo,
      },
      {
        id: "09",
        title: "MAJMC",
        price: "₹ 80,000",
        color: "#20BF6B",
        image: mujlogo,
      },
    ],
  },

  {
    university: "Sikkim Manipal University",
    courses: [
      {
        id: "01",
        title: "BA",
        price: "₹ 75,000",
        color: "#6C63FF",
        image: smulogo,
      },
      {
        id: "02",
        title: "BCom",
        price: "₹ 75,000",
        color: "#FF6B6B",
        image: smulogo,
      },
      {
        id: "03",
        title: "BBA",
        price: "₹ 90,000",
        color: "#00B894",
        image: smulogo,
      },
      {
        id: "05",
        title: "MA",
        price: "₹ 75,000",
        color: "#E17055",
        image: smulogo,
      },
      {
        id: "07",
        title: "MCom",
        price: "₹ 75,000",
        color: "#3867D6",
        image: smulogo,
      },
      {
        id: "08",
        title: "MBA",
        price: "₹ 1,20,000",
        color: "#FC5C65",
        image: smulogo,
      },
      {
        id: "09",
        title: "MCA",
        price: "₹ 1,10,000",
        color: "#A55EEA",
        image: smulogo,
      },
    ],
  },
];